import { type FieldValues, useController } from 'react-hook-form';

import type { TextAreaProps } from '~/components/TextArea';
import { TextArea } from '~/components/TextArea';

import { FormField, type FormFieldProps } from '../../FormField';

type FormFieldTextAreaProps<TFormFields extends FieldValues> = Omit<
  FormFieldProps<TFormFields>,
  'children'
> &
  Omit<TextAreaProps, 'name' | 'className'>;

export function FormFieldTextArea<TFormFields extends FieldValues>({
  name,
  label,
  className,
  disabled = false,
  readOnly = false,
  ...textAreaProps
}: FormFieldTextAreaProps<TFormFields>) {
  const {
    field,
    fieldState: { invalid },
  } = useController({ name, disabled });

  return (
    <FormField
      name={name}
      label={label}
      className={className}
      disabled={disabled}
      readOnly={readOnly}
    >
      <TextArea
        {...field}
        state={invalid ? 'error' : undefined}
        aria-labelledby={name}
        {...textAreaProps}
        disabled={disabled}
        readOnly={readOnly}
      />
    </FormField>
  );
}

FormFieldTextArea.displayName = 'FormFieldTextArea';
